import en from './en.json'
import es from './es.json'

const locales = {
  en,
  es,
} as const

export default locales

export type LocaleKey = keyof typeof locales
